<div class="modal-content">
  <h1 class="modal__heading">{{ 'auto-fill-error-modal-title' | translate }}</h1>
  <h2>{{ 'auto-fill-error-modal-subtitle' | translate }}</h2>
  <p class="modal__paragraph">{{ 'auto-fill-error-modal-info-1' | translate }}</p>
  <p class="modal__paragraph">{{ 'auto-fill-error-modal-info-2' | translate }}</p>
  <button class="btn__primary--inverted" tabindex="0" (click)="closeModal('autofill-error-modal')">
    {{ 'close' | translate }}
  </button>
</div>
